import store from '@/store'
import * as types from '@/store/mutationTypes'

export default flushTypes => result => {
  store.commit(types.FLUSH_RESOURCE_TYPES, flushTypes)
  return result
}
